import {useCallback, useState} from 'react';
import {formsStore} from '../../../../stores/Form/FormsStore';
import {RecordEditState, UpdateActions} from '../../../../stores/Form/enums';
import {createTemporarilyRecord} from '../../../../stores/Form/utils';

export const useRecordDialog = () => {
    const [isRecordDialogOpen, setIsRecordDialogOpen] = useState(false);

    const openNewEmptyRecord = useCallback(() => {
        const {currentScreen} = formsStore;
        const form = currentScreen.getActiveForm();
        createTemporarilyRecord(form);
        //Open Popup only for main form
        if (form.level === 0) {
            currentScreen.setRecordDialog(true);
            setIsRecordDialogOpen(true);
        }
    }, []);

    const hideEmptyRecord = useCallback(async () => {
        const {currentScreen} = formsStore;
        const currentForm = currentScreen.getActiveForm();

        if (currentScreen.editMode !== RecordEditState.default) {
            const isValid = await currentScreen.checkAndSave(UpdateActions.update_save);
            if (!isValid) return;
        }

        if (currentForm.records[currentForm.currentRow].isTemporary) {
            //remove empty temporarily records from the screen
            currentScreen.removeRecordFromClient(currentForm.currentRow);
        }

        currentForm.setCurrentColumnIdByIndex(0);
        setIsRecordDialogOpen(false);
        currentScreen.setRecordDialog(false);
    }, []);

    return {
        isRecordDialogOpen,
        openNewEmptyRecord,
        hideEmptyRecord
    };
};
